module.exports = "<button style=\"width: 100%;\" class=\"btn btn-default\" (click)=\"onPrintInvoice()\">Print</button>\n"